import { render, staticRenderFns } from "./InspectionRequestStatusBadge.vue?vue&type=template&id=a4f57f6c&scoped=true"
import script from "./InspectionRequestStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionRequestStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionRequestStatusBadge.vue?vue&type=style&index=0&id=a4f57f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f57f6c",
  null
  
)

export default component.exports